// extracted by mini-css-extract-plugin
module.exports = {"product-card-carousel":"product-card-carousel_product-card-carousel__U8Zbq","ready":"product-card-carousel_ready___ARtm"};